import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../components/navbar";
import HeroSectionPrime from "../../components/HeroSectionPrime";
import AccordionComponent from "../../components/accordion";
import InfoIcon from "../../components/InfoIcon";
import SectionThree from "./SectionThree";
import SamcreteSection from "./SamcreteSection";
import ContactSection from "./ContactSection";
import Partners from "./Partners";

const accordionData = [
  {
    heading: <>Inspiring Confidence Through <br/>Advanced Healthcare Technology</>,
    body: <>
    H2A Medical Solutions enhances patient care by providing advanced, reliable medical imaging technologies. 
<br/>
Our high-quality diagnostic tools support healthcare professionals in making accurate, timely decisions, leading to better outcomes and increased patient trust. 
<br/><br/>
Committed to innovation, service excellence, and strong partnerships, H2A contributes to a more confident and efficient healthcare system in Egypt.
    
    </>,
    imgSrc: require("../../assets/About/According-1.png"),
  },
  {
    heading: "Driving Agility in Healthcare Innovation",
    body: <>
    H2A Medical Solutions stands at the forefront of healthcare advancement in Egypt, distinguished by its agility in adapting to the evolving needs of the medical community. 
<br/><br/>
This agility extends beyond technology delivery—reflected in the company's responsive customer support, tailored solutions, and proactive approach to service.
    </>,
    imgSrc: require("../../assets/About/According-1.png"),
  },
  {
    heading:
      "Excellence in After-Sales Service",
    body: <>
    After-sales service is a core pillar of the company’s commitment  to long-term value and customer satisfaction. H2A ensures that every product is supported by a dedicated team of highly trained engineers and service professionals.
<br/>
From installation and user training to regular maintenance and prompt technical support, H2A provides a seamless ownership experience that maximizes equipment uptime and performance. This ensures reliable performance and maximized uptime for medical equipment, fostering trust among healthcare providers and enabling them to focus on quality patient care.
    
    </>,
    imgSrc: require("../../assets/About/According-1.png"),
  },
];

const Vision_Mission = [
  {
    title: "Vision",
    iconSrc: require("../../assets/icons/EyeIcon.png"),
    content: <>
    <p>
      Is to be a leading force in the healthcare community, recognized for delivering exceptional medical solutions and supporting advanced patient care through innovative technologies and trusted partnerships. This vision aligns with their dedication to enhancing medical services in line with Egypt’s Vision 2030, aiming to provide caregivers with the right tools to deliver optimal care at the right time and place. Through their collaboration with Philips, H2A is contributing to the advancement of healthcare in Egypt, ensuring that clinicians have access to state-of-the-art diagnostic tools to improve patient outcomes.
    </p>
    </>,
  },
  {
    title: "Mission",
    iconSrc: require("../../assets/icons/MissionIcon.png"),
    content: (
      <>
       To provide high-quality customer-focused services that are accessible, cost-effective, and meet the requirements of the customers we serve.
<br/><br/><br/>
To achieve a unique level of quality and productivity in the delivery of sales, after-sales, and technical support services that respond to the needs and values of our customers.

      </>
    ),
  },
];

function About() {
  return (
    <>
      {/* <Navbar transparent={false} /> */}

      <main className="mt-16">
        <HeroSectionPrime
          lineHeight={"leading-loose"}
          position={"s"}
          widthToggle={true}
          imgSrc={require("../../assets/Hero/About-Hero.png")}
          bgColor={"gradient"}
          title={"About US"}
          content={<>
            <p>

              Founded in 2018, H2A was established to be a pioneer in delivering advanced, comprehensive, and sustainable healthcare solutions to its customers. Since its inception, H2A has proudly served as the official distributor of Philips ultrasound systems in Egypt, providing both sales and maintenance services.
              <br /><br />
              In partnership with Philips—a global leader in medical imaging—H2A offers cutting-edge ultrasound systems supported by expert consultation, technical training, and reliable after-sales service.
              <br />
              As a part of the diversified Egyptian SAMCRETE group, H2A is committed to bridging the gap between supply and demand in Egypt's growing healthcare market.

            </p>

          </>}
        />
        <section>
          {Vision_Mission.map((item, i) => (
            <div
              key={i}
              className={`${i % 2 === 0 && "bg-secondary-color"
                } w-full md:w-1/2 md:px-0 p-5 py-20 inline-block`}
            >
              <div className="w-[75%] m-auto">
                <InfoIcon
                  iconSrc={item.iconSrc}
                  title={item.title}
                  content={item.content}
                />
              </div>
            </div>
          ))}
        </section>

        <section className="m-auto md:px-0 md:w-[85%] w-full p-5   py-20">
          <h3 className="text-xl md:text-3xl">Values </h3>
          <p className="text-sm md:text-lg my-5">
            Our belief at H2A is that Egyptian medical facilities ought to
            provide their patients with an improved diagnostic experience. For
            this reason, we searched the market for the best products available,
            but we were unable to find anything superior to what Philips
            manufactures.
          </p>
          <AccordionComponent accordionData={accordionData} dir={"r"} />
        </section>

        <section className=" flex items-center justify-end min-h-[500px] ">
          <SectionThree />
        </section>
        {/* <Partners /> */}
        <SamcreteSection />
        <ContactSection />
      </main>
    </>
  );
}

export default About;
